export function TokenEventsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Token Events</h1>
      <p className="text-muted-foreground">Monitor token events and transfers.</p>
    </div>
  );
}
